import { createServer } from 'miragejs';
import { getQueryStringParsed } from '../utils/queryString';
import get from 'lodash-es/get';
export default () => {
  const queryParams = getQueryStringParsed(get(window, 'location.search', ''));

  // eslint-disable-next-line no-console
  console.log('CREATE_MOCK_SERVER:', process.env.REACT_APP_CREATE_MOCK_SERVER);
  console.log('__MARKET__:', __MARKET__);
  console.log('__DEV__:', __DEV__);

  if (process.env.REACT_APP_CREATE_MOCK_SERVER === 'true') {
    const server = createServer();

    // const eligibilitySuccessWithNoEquitiesProducts = (() => {
    //   try {
    //     return require(`./api/eligibility/${__MARKET__}/success_with_NoEquitiesProducts.json`);
    //   } catch (_) {
    //     return {};
    //   }
    // })(__MARKET__);

    const applicationSubmitNotCreated = (() => {
      try {
        return require(`./api/applicationSubmit/${__MARKET__}/not_created.json`);
      } catch (_) {
        return {};
      }
    })(__MARKET__);

    const applicationSubmitAcceptPage = (() => {
      try {
        return require(`./api/applicationSubmit/${__MARKET__}/created.json`);
      } catch (_) {
        return {};
      }
    })(__MARKET__);

    const applicationSubmitReferPage = (() => {
      try {
        return require(`./api/applicationSubmit/${__MARKET__}/refer.json`);
      } catch (_) {
        return {};
      }
    })(__MARKET__);

    const ineligiblePage = (() => {
      try {
        return require(`./api/applicationSubmit/${__MARKET__}/ineligible_page.json`);
      } catch (_) {
        return {};
      }
    })(__MARKET__);

    const accountList = (() => {
      try {
        return require(`./api/eligibility/${__MARKET__}/account_list.json`);
      } catch (_) {
        return {};
      }
    })(__MARKET__);

    const eliglibleProducts = (() => {
      try {
        return require(`./api/eligibility/${__MARKET__}/eliglible_products.json`);
      } catch (_) {
        return {};
      }
    })(__MARKET__);

    const customerInfo = (() => {
      try {
        return require(`./api/eligibility/${__MARKET__}/customer_info.json`);
      } catch (_) {
        return {};
      }
    })(__MARKET__);

    const sessionTimeoutAPI =
      'originations/etb/iao/api/v0/application-data-review';
    const sessionTimeoutStatus = get(queryParams, 'sessiontimeout', 200);
    server.get(
      sessionTimeoutAPI,
      {
        errors: 'sessiontimeout',
      },
      parseInt(sessionTimeoutStatus)
    );
    const eligibilityAPI =
      'originations/etb/iao/api/v0/investment-eligibilities';
    if (queryParams.page && queryParams.page === 'ineligible') {
      server.get(eligibilityAPI, ineligiblePage);
    } else if (queryParams.page && queryParams.page === 'technicalerror') {
      server.get(
        eligibilityAPI,
        {
          errors: 'Technnical Error Page',
        },
        500
      );
    } else {
      const accountlistAPI = 'originations/etb/iao/api/v0/investment-accounts';
      server.get(accountlistAPI, accountList);
      // server.get(eligibilityAPI, eligibilitySuccessWithNoEquitiesProducts);
      server.get(eligibilityAPI, eliglibleProducts);
      const appReviewDataAPI =
        'originations/etb/iao/api/v0/application-data-review';
      server.get(appReviewDataAPI, customerInfo);

      const decisionAPI = 'originations/etb/iao/api/v0/account-submission';
      if (queryParams.onsubmit && queryParams.onsubmit === 'accept') {
        server.post(decisionAPI, applicationSubmitAcceptPage);
      } else if (queryParams.onsubmit && queryParams.onsubmit === 'refer') {
        server.post(decisionAPI, applicationSubmitReferPage);
      } else if (
        queryParams.onsubmit &&
        queryParams.onsubmit === 'not_created'
      ) {
        server.post(decisionAPI, applicationSubmitNotCreated);
      } else {
        server.post(
          decisionAPI,
          {
            errors: 'Technnical Error Page',
          },
          500
        );
      }
    }
  }
};
